import { useQuery } from "@tanstack/react-query";
import { useOrg360Api } from "./useOrg360Api";
import type { FieldSecurityData } from "@/components/organisms/org360/org360Types";

export function useOrg360FieldSecurity(objectName: string | null) {
  const { getJson, orgId } = useOrg360Api();

  return useQuery({
    queryKey: ["org360-field-security", orgId, objectName],
    queryFn: async () => {
      if (!objectName) return null;
      const res = await getJson<{ ok: boolean; data: FieldSecurityData }>(
        "/api/object/field-access",
        { org_id: orgId, object: objectName },
      );
      return res?.data ?? null;
    },
    enabled: !!orgId && !!objectName,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
